import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import ProductsCard from "../components/common/card/ProductsCard";
import BestProducts from "../components/common/products/BestProducts";
import { httpReauest } from "../utils/httpRequest";
import { CDN_BASE_URL } from "../config";
import { Link, useLocation } from "react-router-dom";
import Loading from "../components/common/Loading";
import { Helmet } from "react-helmet";
import { toEnglishDigits } from "../components/common/mobile/ProductsMobile";
import { useRouteInfo } from "../hooks/useRouteInfo";

const BrandsPage = () => {
  const [loading, setLoading] = useState();

  const [brands, setBrands] = useState();
  const [category, setcategory] = useState();
  const [uniquebrands, setuniquebrands] = useState();
  const [selectedCategory, setselectedCategory] = useState(false);
  const { metaData } = useRouteInfo();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    setLoading(true);
    await httpReauest("GET", "/brand", {}, {}).then(({ data }) => {
      setBrands(data?.data);
    });
    await httpReauest("GET", "/category/header", {}, {}).then(({ data }) => {
      setuniquebrands(data?.data.brands);
    });
    await httpReauest("GET", "/category", {}, {}).then(({ data }) => {
      setcategory(data?.data);
    });
    setLoading(false);
  }

  async function handleChange(e) {
    setLoading(true);

    const value = toEnglishDigits(e.target.value);

    await httpReauest("GET", "/brand?search_key=" + value, {}, {}).then(
      ({ data }) => {
        setBrands(data?.data);
      }
    );
    setLoading(false);
  }

  return (
    <div className="pt-8 w-full container_1">
      <Helmet>
        <meta charSet="utf-8" />
        <title>{metaData?.meta_title}</title>
        <meta name="description" content={metaData?.meta_desc} />
        <meta name="og:description" content={metaData?.meta_desc} />
        <meta name="og:title" content={metaData?.meta_title} />
        <link rel="canonical" href={metaData?.canonical} />
        <meta property="og:type" content={metaData?.meta_type} />
      </Helmet>{" "}
      <h1 className="title text-center">{metaData?.h1}</h1>
      <div className="my-8 flex justify-center">
        {" "}
        <span className="relative  w-[60%]">
          <input
            className="w-full form-brand xl:min-w-[210px] h-[58px]"
            placeholder="مثلا: BENZ"
            onChange={handleChange}
          />
          <p className="on-border font-bold">جستجو</p>
          <img
            src="/Filter.png"
            alt="filter"
            className="absolute translate-y-[-50%] top-[50%] left-4"
          />
          <img
            src="/Filter2.png"
            alt="filter"
            className="absolute translate-y-[-50%] top-[50%] left-12"
          />
        </span>
      </div>
      <div className="my-12">
        <h3 className="text-[20px] font-[700]">برند ها </h3>
        <div className="mt-4 flex  gap-4 flex-wrap">
          {loading ? (
            <Loading />
          ) : selectedCategory ? (
            uniquebrands?.map((e) => {
              if (e.category === selectedCategory._id) {
                return (
                  <span className="flex flex-col justify-center items-center">
                    <span
                      style={{ borderStyle: "dashed" }}
                      className="border-brand py-3  min-w-[90px] min-h-[80px] w-full h-full mb-0.5"
                    >
                      <Link
                        to={"/brands/" + e.brand.name}
                        className="flex justify-center items-center"
                      >
                        <img
                          className="w-[62px] h-[62px] object-contain"
                          alt={e.brand.name}
                          title={e.brand.name}
                          src={CDN_BASE_URL + e.brand.logo}
                        />
                      </Link>
                    </span>
                    <p>{e.brand.title}</p>
                  </span>
                );
              }
            })
          ) : (
            brands?.map((e) => (
              <span className="flex flex-col justify-center items-center">
                <span
                  style={{ borderStyle: "dashed" }}
                  className="border-brand py-3  min-w-[90px] min-h-[80px] w-full h-full mb-0.5"
                >
                  <Link
                    to={"/brands/" + e.name}
                    className="flex justify-center items-center"
                  >
                    <img
                      className="w-[62px] h-[62px] object-contain"
                      alt={e.name}
                      title={e.name}
                      src={CDN_BASE_URL + e.logo}
                    />
                  </Link>
                </span>
                <p>{e.title}</p>
              </span>
            ))
          )}
        </div>
      </div>
      <div className="my-12">
        <h3 className="text-[20px] font-[700]">دسته بندی ها </h3>
        <div className="grid grid-cols-5 gap-5 mt-4">
          {category?.map((e) => (
            <span
              onClick={() =>
                selectedCategory?._id === e?._id
                  ? setselectedCategory(false)
                  : setselectedCategory(e)
              }
              className={`${
                selectedCategory?._id === e?._id ? "bg-black text-white" : ""
              } cursor-pointer border-brand py-5 flex justify-center gap-4 items-center`}
            >
              <img
                className="w-[35%]"
                alt="category"
                src={CDN_BASE_URL + e?.img}
              />
            </span>
          ))}
        </div>
      </div>
      <div className="my-12">
        <BestProducts />
      </div>
    </div>
  );
};

export default BrandsPage;
